














































import { Vue, Component, Prop, Inject, Ref } from "vue-property-decorator";
import * as Xlsx from "xlsx";
@Component({
  name: "FastInMain",
  components: {}
})
export default class FastInMain extends Vue {
  private group: App.WebForm.DataGroup = { name: "", widgets: [] };
  private visible: boolean = false;
  private form: any = {};
  private rows: number = 0;
  private columns: number = 1;

  private excel: Array<{ label: string; key: string }> = [];

  @Ref("file")
  private file!: HTMLInputElement;

  @Prop({ required: true })
  private options!: {
    template: string;
    widgets: App.WebForm.Widget[];
    width: number | string;
    group: Array<App.WebForm.DataGroup>;
  };
  @Inject({ from: "client", default: "web" })
  private client!: "web" | "mobile";

  @Inject({ from: "model", default: {} })
  private model!: any;

  submit() {
    this.group.widgets.forEach((d) => {
      const widget = this.options.widgets.find((w) => w.id === d);
      if (widget) {
        this.$set(this.model, widget.property.propertyName, this.form[d]);
      }
    });
    this.visible = false;
  }

  show(group: App.WebForm.DataGroup) {
    this.group = group;

    const form: any = {};
    const excel: Array<{ label: string; key: string }> = [];
    this.group.widgets.forEach((d) => {
      const widget = this.options.widgets.find((w) => w.id === d);
      if (widget) {
        form[d] = this.model[widget.property.propertyName];
        if (!widget.readonly) {
          excel.push({
            label: widget.name || "",
            key: d
          });
        }
      }
    });
    this.excel = excel;
    this.form = form;
    this.columns = this.client === "web" ? 3 : 4;
    this.rows = Math.ceil(this.group.widgets.length / this.columns);

    this.visible = true;
  }

  getWidget(row: number, column: number) {
    const wid = this.group.widgets[row * this.rows + column];
    const widget = this.options.widgets.find((d) => d.id === wid);
    return widget;
  }

  getReadOnly(row: number, column: number) {
    const widget = this.getWidget(row, column);
    return !!widget?.readonly;
  }

  getLabel(row: number, column: number) {
    const widget = this.getWidget(row, column);
    return widget?.name || "";
  }

  getFormProp(row: number, column: number) {
    const index = row * this.rows + column;
    return this.group.widgets[index];
  }

  getInputType(row: number, column: number) {
    const widget = this.getWidget(row, column);
    return widget?.type === "TextWidget" ? "textarea" : "";
  }

  isExist(row: number, column: number) {
    const len = row * this.rows + column;
    return len < this.group.widgets.length;
  }

  get params() {
    const params: any = {};
    if (this.client === "web") {
      params.width = "1100px";
    } else {
      params.fullscreen = true;
    }
    return params;
  }

  async onFileChange() {
    const files = this.file.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    const buf = await file.arrayBuffer();
    const workbook = Xlsx.read(buf);
    const json = Xlsx.utils.sheet_to_json(
      workbook.Sheets[workbook.SheetNames[0]]
    );
    if (json.length > 0) {
      const data = json[0] as any;
      const form: any = {};
      this.excel.forEach((d) => {
        form[d.key] = data[d.label];
      });
      this.form = { ...this.form, ...form };
      this.$message.success("文件解析完毕");
    } else {
      this.$message.error("文件解析失败");
    }
  }

  importExcel() {
    this.file.value = "";
    this.file.click();
  }

  exportExcel() {
    const worksheet = Xlsx.utils.json_to_sheet([]);
    const workbook = Xlsx.utils.book_new();
    Xlsx.utils.book_append_sheet(workbook, worksheet, "数据");
    const header = this.excel.map((d) => d.label);
    Xlsx.utils.sheet_add_aoa(worksheet, [header], {
      origin: "A1"
    });

    const wch = header.map((d) => {
      return {
        wch: d.length * 2 + 3
      };
    });

    worksheet["!cols"] = [...wch];

    Xlsx.writeFile(workbook, "导入模板.xlsx");
  }
}
